import React from 'react';
import {View} from 'react-native';

import Checkbox from '/component/base/Checkbox';
import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import ListItem from '../ListItem';

import {styles} from './ListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={1}>Label and Suffix</Heading>
      <Spacer size={16} />
      <Text>
        This is a <Code>{'ListItem'}</Code> with a <Code>{'label'}</Code> and{' '}
        <Code>{'suffix'}</Code> prop.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter style={styles.gutter}>
        <ListItem
          suffix={<Text>18</Text>}
          label={<Text>Ordering Entities</Text>}
        />
      </Gutter>
    </View>

    <Spacing size={20}>
      <Heading level={1}>Prefix and Label</Heading>
      <Spacer size={16} />
      <Text>
        This is a <Code>{'ListItem'}</Code> with a <Code>{'prefix'}</Code> and{' '}
        <Code>{'label'}</Code> prop.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter style={styles.gutter}>
        <ListItem
          prefix={<Checkbox checked />}
          label={<Text>Highest Achievement Rank</Text>}
        />
      </Gutter>
    </View>
  </>
);
